
import { BoxMaintenancePage } from './index.box';
import { CloudMaintenancePage } from './index.cloud';
import { DemoMaintenancePage } from './index.demo';

import { mixin } from '@cems-eco/core/src/utils/platform';
import environment from "@/config";

export default class MaintenanceIndex extends mixin(environment.nexus, {
  box: BoxMaintenancePage,
  cloud: CloudMaintenancePage,
  demo: DemoMaintenancePage
}) { }
